import { CompositeFilterDescriptor, FilterDescriptor, State } from '@progress/kendo-data-query';
import { GridColumnMenuFilter, GridColumnMenuProps, GridColumnMenuSort } from '@progress/kendo-react-grid';
import React from 'react';
import { ILocationDto, IMessageDto } from '../api/client';

export const onLocationFilterChange = (
  locationFilters: ILocationDto[],
  dataState: State,
  updateGridState: (dataState: State) => void,
) => {
  const newFilters: CompositeFilterDescriptor = {
    filters: locationFilters.map(
      (filter) =>
        ({
          field: 'location.name',
          operator: 'neq',
          value: filter.name,
        } as FilterDescriptor),
    ),
    logic: 'and',
  };
  if (dataState.filter) {
    let currentFilters: CompositeFilterDescriptor[] = dataState.filter.filters as CompositeFilterDescriptor[];
    currentFilters = currentFilters.filter((filter) => {
      const f = filter.filters[0] as FilterDescriptor;
      return f.field !== 'location.name';
    });

    if (!locationFilters.length) {
      updateGridState({ ...dataState, filter: { filters: currentFilters, logic: 'and' } });
      return;
    }

    currentFilters.push(newFilters);
    updateGridState({ ...dataState, filter: { filters: currentFilters, logic: 'and' } });
  } else {
    if (!locationFilters.length) {
      updateGridState({ ...dataState, filter: { filters: [], logic: 'and' } });
      return;
    } else {
      updateGridState({ ...dataState, filter: { filters: [newFilters], logic: 'and' } });
    }
  }
};

export const isColumnActive = (field: string, dataState: State) => GridColumnMenuFilter.active(field, dataState.filter);

export const renderColumnMenu = (
  props: GridColumnMenuProps,
  notFilterable: boolean | undefined,
  twoFilterCriteria: boolean | undefined,
) => (
  <div>
    <GridColumnMenuSort {...props} />
    {!notFilterable ? <GridColumnMenuFilter {...props} hideSecondFilter={!twoFilterCriteria} /> : null}
  </div>
);

export const formatDate = (date: Date, includeTimeStamp?: boolean) => {
  if (typeof date === 'object') {
    if (includeTimeStamp === true) {
      //returns date with timestamp ex: 7/2/2021, 2:05:07 PM
      return date.toLocaleString();
    } else {
      //returns date without timestamp ex: 7/2/2021
      return date.toLocaleDateString();
    }
  } else return date;
};

export const numberOfDaysTillPermDelete = (date: { getTime: () => number }) => {
  if (date !== null && date !== undefined) {
    const currentDate = new Date();
    const time_difference = currentDate.getTime() - date.getTime();
    const days_difference = time_difference / (1000 * 60 * 60 * 24);
    return Math.floor((window as any).CSG_CONFIG.DAYS_TILL_PERM_DELETE - days_difference);
  }
  return Number.MAX_SAFE_INTEGER;
};

export const formatGridData = (messages: IMessageDto[]) => {
  const formatStatus = (status: number) => {
    switch (status) {
      case 0:
        return 'Draft';
      case 1:
        return 'Pending';
      case 2:
        return 'Approved';
      default:
        return 'Unknown';
    }
  };

  const formatBoolean = (bool: boolean) => {
    if (bool) {
      return 'Yes';
    } else {
      return 'No';
    }
  };

  return messages.map((message) => {
    return {
      ...message,
      status: formatStatus(message.status),
      beginDate: message.beginDateUserEntry ? formatDate(new Date(message.beginDateUserEntry)) : null,
      endDate: message.endDateUserEntry ? formatDate(new Date(message.endDateUserEntry)) : null,
      createDate: message.createDate ? formatDate(message.createDate) : null,
      approvalDate: message.approvalDate ? formatDate(message.approvalDate) : null,
      forceHardcopy: formatBoolean(message.forceHardcopy),
      isRequired: formatBoolean(message.isRequired),
      isOverflowAllowed: formatBoolean(message.isOverflowAllowed),
    };
  });
};
